// extracted by mini-css-extract-plugin
export default {"subtitle":"PageTitle_subtitle__e1w5t"};